export const secondsToMs = 1000;
export const minutesToMs = 60 * secondsToMs;
export const hoursToMs = 60 * minutesToMs;
export const daysToMs = 24 * hoursToMs;
export const weeksToMs = 7 * daysToMs;
export const monthsToMs = 30 * daysToMs;
export const yearsToMs = 365 * daysToMs;
